import { BRIDGE_ERROR } from '../constants/bridge';
import { fail, isResult } from './result';

// Runs `task` with an internal AbortSignal that fires on timeout or when the
// caller's signal aborts. Anything the task resolves afterwards is ignored, so
// a late native callback can never turn a timeout into a success.
export function runWithTimeout(task, { timeoutMs, signal } = {}) {
    if (signal?.aborted) return Promise.resolve(fail(BRIDGE_ERROR.CANCELLED));

    const controller = new AbortController();

    return new Promise((resolve) => {
        let isSettled = false;
        let timer = null;

        function settle(result) {
            if (isSettled) return;
            isSettled = true;
            clearTimeout(timer);
            signal?.removeEventListener('abort', handleAbort);
            resolve(result);
        }

        function handleAbort() {
            controller.abort('cancelled');
            settle(fail(BRIDGE_ERROR.CANCELLED));
        }

        if (Number.isFinite(timeoutMs) && timeoutMs > 0) {
            timer = setTimeout(() => {
                controller.abort('timeout');
                settle(fail(BRIDGE_ERROR.TIMEOUT));
            }, timeoutMs);
        }
        signal?.addEventListener('abort', handleAbort, { once: true });

        Promise.resolve()
            .then(() => controller.signal.aborted
                ? fail(BRIDGE_ERROR.CANCELLED)
                : task({ signal: controller.signal }))
            .then(
                (result) => settle(isResult(result) ? result : fail(BRIDGE_ERROR.INVALID_RESPONSE)),
                () => settle(fail(BRIDGE_ERROR.FAILED)),
            );
    });
}
